import React, { useMemo, useState } from 'react';
import { Configure } from 'react-instantsearch-dom';
import styled from 'styled-components';

import { mediaQueries } from '@general/breakpoints';
import { BodyLarge, DivWithShadowAlternate } from '@react/styledComponents';
import SearchContainer from '@react/components/search/SearchContainer';
import AnnouncementContent from './AnnouncementContent';
import AnnouncementsList from './AnnouncementsList';
import AnnouncementsSearchBox from './AnnouncementsSearchBox';
import PagingToolbar from '../../../../../algolia-search/js/components/sections/PagingToolbar';

const ContainerStyled = styled(DivWithShadowAlternate)`
    padding: 16px;
    margin-bottom: 1rem;

    @media ${mediaQueries.md} {
        margin: 0;
        padding: 24px;
    }
`;

const SidebarStyled = styled.div`
    width: 100%;
    z-index: 1; // fixes issue with tooltips overlapping with window with fade-in-fast

    @media ${mediaQueries.md} {
        width: 35%;
        min-width: 300px;
        height: 100%;
    }
`;

const ContainerMainStyled = styled.div`
    width: 100%;

    @media ${mediaQueries.md} {
        bottom: 0;
        left: max(calc(35% + 20px), 320px);
        position: absolute;
        width: min(calc(65% - 20px), calc(100% - 320px));
        height: 100%;
    }
`;

const TrusteeAnnouncements = () => {
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [activeAnnouncement, setActiveAnnouncement] = useState(null);

    const filters = useMemo(() => {
        const nineMonthsAgo = new Date();
        nineMonthsAgo.setMonth(nineMonthsAgo.getMonth() - 9);
        const nineMonthsAgoTimestamp = Math.floor(nineMonthsAgo.getTime() / 1000);
        return `created_at_timestamp >= ${nineMonthsAgoTimestamp}`;
    }, []);

    return (
        <SearchContainer index="announcements">
            <Configure clickAnalytics filters={filters} hitsPerPage={5} />
            <ContainerStyled className="fade-in-fast">
                <BodyLarge className="mb-2rem">Explore all Trustee Email Communications in one place.</BodyLarge>

                <div className="flex flex-col relative md:flex-row" style={{ gap: '20px' }}>
                    <SidebarStyled>
                        <div className="mb-1rem">
                            <AnnouncementsSearchBox />
                        </div>

                        <AnnouncementsList
                            activeAnnouncement={activeAnnouncement}
                            onClickItem={setActiveAnnouncement}
                            onLoaded={() => setIsFirstLoad(false)}
                        />

                        <PagingToolbar />
                    </SidebarStyled>

                    <ContainerMainStyled>
                        <div className="h-full">
                            <AnnouncementContent announcement={activeAnnouncement} isFirstLoad={isFirstLoad} />
                        </div>
                    </ContainerMainStyled>
                </div>
            </ContainerStyled>
        </SearchContainer>
    );
};

export default TrusteeAnnouncements;
